import { spring } from './spring/index.mjs';
import { calcGeneratorVelocity } from './utils/velocity.mjs';
function inertia(_ref) {
  var keyframes = _ref.keyframes,
    _ref$velocity = _ref.velocity,
    velocity = _ref$velocity === void 0 ? 0.0 : _ref$velocity,
    _ref$power = _ref.power,
    power = _ref$power === void 0 ? 0.8 : _ref$power,
    _ref$timeConstant = _ref.timeConstant,
    timeConstant = _ref$timeConstant === void 0 ? 325 : _ref$timeConstant,
    _ref$bounceDamping = _ref.bounceDamping,
    bounceDamping = _ref$bounceDamping === void 0 ? 10 : _ref$bounceDamping,
    _ref$bounceStiffness = _ref.bounceStiffness,
    bounceStiffness = _ref$bounceStiffness === void 0 ? 500 : _ref$bounceStiffness,
    modifyTarget = _ref.modifyTarget,
    min = _ref.min,
    max = _ref.max,
    _ref$restDelta = _ref.restDelta,
    restDelta = _ref$restDelta === void 0 ? 0.5 : _ref$restDelta,
    restSpeed = _ref.restSpeed;
  var origin = keyframes[0];
  var state = {
    done: false,
    value: origin
  };
  var isOutOfBounds = function isOutOfBounds(v) {
    return min !== undefined && v < min || max !== undefined && v > max;
  };
  var nearestBoundary = function nearestBoundary(v) {
    if (min === undefined) return max;
    if (max === undefined) return min;
    return Math.abs(min - v) < Math.abs(max - v) ? min : max;
  };
  var amplitude = power * velocity;
  var ideal = origin + amplitude;
  var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
  /**
   * If the target has changed we need to re-calculate the amplitude, otherwise
   * the animation will start from the wrong position.
   */
  if (target !== ideal) amplitude = target - origin;
  var calcDelta = function calcDelta(t) {
    return -amplitude * Math.exp(-t / timeConstant);
  };
  var calcLatest = function calcLatest(t) {
    return target + calcDelta(t);
  };
  var applyFriction = function applyFriction(t) {
    var delta = calcDelta(t);
    var latest = calcLatest(t);
    state.done = Math.abs(delta) <= restDelta;
    state.value = state.done ? target : latest;
  };
  /**
   * Ideally this would resolve for t in a stateless way, we could
   * do that by always precalculating the animation but as we know
   * this will be done anyway we can assume that spring will
   * be discovered during that.
   */
  var timeReachedBoundary;
  var spring$1;
  var checkCatchBoundary = function checkCatchBoundary(t) {
    if (!isOutOfBounds(state.value)) return;
    timeReachedBoundary = t;
    spring$1 = spring({
      keyframes: [state.value, nearestBoundary(state.value)],
      velocity: calcGeneratorVelocity(calcLatest, t, state.value),
      // TODO: This should be passing * 1000
      damping: bounceDamping,
      stiffness: bounceStiffness,
      restDelta: restDelta,
      restSpeed: restSpeed
    });
  };
  checkCatchBoundary(0);
  return {
    calculatedDuration: null,
    next: function next(t) {
      /**
       * We need to resolve the friction to figure out if we need a
       * spring but we don't want to do this twice per frame. So here
       * we flag if we updated for this frame and later if we did
       * we can skip doing it again.
       */
      var hasUpdatedFrame = false;
      if (!spring$1 && timeReachedBoundary === undefined) {
        hasUpdatedFrame = true;
        applyFriction(t);
        checkCatchBoundary(t);
      }
      /**
       * If we have a spring and the provided t is beyond the moment the friction
       * animation crossed the min/max boundary, use the spring.
       */
      if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) {
        return spring$1.next(t - timeReachedBoundary);
      } else {
        !hasUpdatedFrame && applyFriction(t);
        return state;
      }
    }
  };
}
export { inertia };